// @flow
import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import {usePrefs} from 'docs/data';
import type {ReadersForCountry} from 'docs/data/integration-builder';
import {Setting} from './Setting';

const messages = defineMessages({
  reader: {
    id: 'docsApp.integrationBuilder.settings.reader',
    description: 'Terminal reader label',
    defaultMessage: 'Reader:',
  },
});

type ReaderSettingProps = {|
  readersForCountry: ReadersForCountry,
|};

export const ReaderSetting = ({readersForCountry}: ReaderSettingProps) => {
  const {getPref, setPrefs} = usePrefs();
  const countryPref = getPref('country');
  const readerPref = getPref('reader');
  const countries = Object.keys(readersForCountry);
  let reader;
  let readers;

  if (countryPref && countries.includes(countryPref)) {
    // The user has a valid country set as a pref, default to that
    // country and pick a reader from the list based on the reader pref
    readers = readersForCountry[countryPref];
    if (readerPref && readersForCountry[countryPref].includes(readerPref)) {
      reader = readerPref;
    } else {
      readers = readersForCountry[countryPref];
      reader = readers[0];
      setPrefs({reader});
    }
  } else {
    readers = readersForCountry[countries[0]];
    reader = readers[0];
    setPrefs({country: countries[0], reader});
  }

  return (
    <Setting
      label={<FormattedMessage {...messages.reader} />}
      pref="reader"
      activeItem={reader}
      items={readers}
    />
  );
};
